(function () {
    'use strict';

    angular
        .module('app')
        .directive('emailValidator', emailValidator);

    function emailValidator(){
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                formError: '=emailValidatorError',
                emailValidated: '=emailValidatorValidated',
                emailValidatedCallback: '=emailValidatedCallback'
            },
            link: function ($scope, elm, attrs, ctrl){

                // only apply the validator if ngModel is present and Angular has added the email validator
                if (ctrl && ctrl.$validators.email) {
                    // trigger on key up event
                    elm.on('keyup', validateOnKeyup);
                }

                function validateOnKeyup(){
                    //cancel the last timeout
                    clearTimeout($scope.timeOut);
                    $scope.emailValidated = false;
                    ctrl.$setValidity("emailValidated", false);

                    // get email value
                    var email = ctrl.$viewValue;

                    // wait for user to stop typing before processing validity
                    $scope.timeOut = setTimeout(function(){
                        // force apply to update error message consistently
                        $scope.$apply(function(){
                            // check if email field has been deleted completely
                            if(email === "" || !email) {
                                $scope.formError = "Email address is required";
                                return;
                            }

                                $scope.emailValidatedCallback().then(function(error){
                                    if (error){
                                        $scope.formError = error;
                                        $scope.emailValidated = false;
                                        ctrl.$setValidity("emailValidated", false);
                                    } else {
                                        $scope.formError = "";
                                        $scope.emailValidated = true;
                                        ctrl.$setValidity("emailValidated", true);
                                    }
                                });
                        });
                    }, 500);
                }
            }
        };
    }
})();